import dataProvider from "./dataProvider";

export default dataProvider;
